import React, { useState } from "react";
import Modal from "react-modal";
import axios from "axios";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

Modal.setAppElement("#root");
export default function SideBar() {
  const [modalIsOpen, setIsOpen] = useState(false);

  const [eventObj, seteventObj] = useState({
    name: "",
    Date: "",
    endTime: "",
    startTime: "",
    Day: "",
    id: 0,
  });

  const toggleModal = () => {
    setIsOpen(!modalIsOpen);
  };

  const onSubmit = () => {
    //post event to create new event
    console.log(eventObj, "submitted obj");
    axios
      .post("https://anhrey.deta.dev/event", eventObj)
      .then(function (response) {
        console.log(response.data);
      })
      .catch((error) => console.log(error));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    seteventObj((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  /*   
    "Day": "Wednesday",
    "startTime": "9:00 PM",
    "endTime": "10:00 PM",
    "name": "My class",
    "Date": "2021-03-17" */

  console.log(eventObj, "me event obj hu");
  return (
    <div className="SideBar">
      <Modal
        isOpen={modalIsOpen}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <h1>Add a new Event:</h1>
        <div class="form">
          <div>
            <label>
              EventName:
              <input
                type="text"
                name="name"
                value={eventObj.name}
                onChange={handleChange}
              />
            </label>
          </div>
          <br></br>
          <label>
            StartTime:
            <input
              type="text"
              name="startTime"
              value={eventObj.startTime}
              onChange={handleChange}
              placeholder={"hh:mm PM/AM"}
            />
          </label>
        </div>
        <br></br>
        <div>
          <label>
            EndTime:
            <input
              type="text"
              name="endTime"
              value={eventObj.endTime}
              onChange={handleChange}
              placeholder={"hh:mm PM/AM"}
            />
          </label>
        </div>
        <br></br>
        <div>
          <label>
            Enter Day:
            <input
              type="text"
              name="Day"
              value={eventObj.Day}
              onChange={handleChange}
              placeholder={"Sunday, Monday, Tuesday"}
            />
          </label>
        </div>
        <br></br>
        <div>
          <label>
            Enter Date:
            <input
              type="text"
              name="Date"
              value={eventObj.Date}
              onChange={handleChange}
              placeholder={"YYYY-MM-DD"}
            />
          </label>
        </div>
        <br></br>
        <button class="btn" onClick={toggleModal}>
          Close
        </button>{" "}
        <button class="btn" onClick={onSubmit}>
          Add Event
        </button>
      </Modal>
      <div class="sidebar-container">
        <button class="sidebar-button" onClick={toggleModal}>
          + ADD EVENT
        </button>{" "}
      </div>
    </div>
  );
}
